// Cross-app links HQ → estimator (mirror of estimator src/config/appLinks.js).

export function estimatorUrlFor(hostname) {
  const h = String(hostname || '').toLowerCase();
  if (h === 'azpoolbuilds.com' || h.endsWith('.azpoolbuilds.com')) return 'https://estimator.azpoolbuilds.com/';
  if (h.endsWith('.workers.dev')) return 'https://apb-estimator.poolbuilders-az.workers.dev/';
  if (h === 'localhost' || h === '127.0.0.1') return 'http://localhost:5173/';
  return null;
}

// Where to send a signed-out HQ visitor: the estimator's /sso handoff page.
export function ssoStartUrl(hostname, returnTo) {
  const base = estimatorUrlFor(hostname);
  if (!base) return null;
  const u = new URL('sso', base);
  u.searchParams.set('to', returnTo);
  return u.toString();
}

// The estimator returns us to <hq url>#sso_token=<single-use token>.
export function readSsoToken(hash) {
  const m = /(?:^#|&)sso_token=([^&]+)/.exec(hash || '');
  return m ? decodeURIComponent(m[1]) : null;
}
